'use es6';

export const TICKET_STATUS_CHANGED = 'TICKET_STATUS_CHANGED';